import {
  UPDATE_TOKEN,
  UPDATE_URL,
  UPDATE_BASE_URL,
  UPDATE_SERVER_URL,
  UPDATE_IMAGES_PATH,
  UPDATE_AUTHORIZATION_STATE,
  UPDATE_AUTHORIZED_USER,
  UPDATE_AUTHORIZED_USER_SCREEN_NAME,
  UPDATE_AUTHORIZED_USER_AVATAR,
  UPDATE_USER_SETTINGS,
  UPDATE_SOCKET_URL,
  UPDATE_SOCKETCLUSTER_URL,
  LOGOUT,
  FAVORITE_MAP_SUCCESS
} from 'constants';

export const connection = (state = {
  logged_in: false,
  token: '',
  user: {
    features: []
  },
}, action) => {
  var { payload, type } = action;
  switch (type) {
    case LOGOUT:
      return {...state, user: {features: []}, logged_in: false};
    case FAVORITE_MAP_SUCCESS:
      return {...state, user: {...state.user, favorites: payload.favorites}}
    case UPDATE_TOKEN:
      return Object.assign({}, state, {
        token: payload.token
      });
    case UPDATE_URL:
      return Object.assign({}, state, {
        url: payload.url
      });
    case UPDATE_BASE_URL:
      return Object.assign({}, state, {
        baseUrl: payload.baseUrl
      });
    case UPDATE_SERVER_URL:
      return Object.assign({}, state, {
        serverUrl: payload.serverUrl
      });
    case UPDATE_IMAGES_PATH:
      return Object.assign({}, state, {
        imagesPath: payload.imagesPath
      });
    case UPDATE_AUTHORIZATION_STATE:
      return Object.assign({}, state, {
        logged_in: payload.logged_in
      });
    case UPDATE_AUTHORIZED_USER:
      return {
				...state,
				user : {...state.user, ...payload.user}
			}
    case UPDATE_AUTHORIZED_USER_SCREEN_NAME:
      return {...state, user: {...state.user, screen_name: payload.screen_name } };
    case UPDATE_AUTHORIZED_USER_AVATAR:
      return {...state, user: {...state.user, avatar: payload.avatar } }
    case UPDATE_USER_SETTINGS:
      var settings = state.settings ? state.settings : {};
      return {...state, user: {...state.user, settings: {...settings, ...payload } } };
    case UPDATE_SOCKET_URL:
      return Object.assign({}, state, {
        socketUrl: payload.socketUrl
      });
    case UPDATE_SOCKETCLUSTER_URL:
      return Object.assign({}, state, {
        socketServer: payload.socketCluster
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/common/reducers/connection.js